<template>
    <div>
        <table>
            <tr>
                <td>
                    <img v-if="lvId==='11'" src="../../../../assets/wappen/Burgenland.png" width="80"/>
                    <img v-else-if="lvId==='12'" src="../../../../assets/wappen/Kaernten.png" width="80"/>
                    <img v-else-if="lvId==='13'" src="../../../../assets/wappen/Niederoesterreich.png" width="60"/>
                    <img v-else-if="lvId==='14'" src="../../../../assets/wappen/OberoesterreichFlag.png"
                         height="80" width="80" style="border: solid 1px grey; object-fit: cover;"/>
                    <img v-else-if="lvId==='15'" src="../../../../assets/wappen/Salzburg.png" width="52"/>
                    <img v-else-if="lvId==='16'" src="../../../../assets/wappen/SteiermarkFlag.png"
                         height="80" width="80" style="border: solid 1px grey; object-fit: cover;"/>
                    <img v-else-if="lvId==='17'" src="../../../../assets/wappen/Tirol.png" width="70"/>
                    <img v-else-if="lvId==='18'" src="../../../../assets/wappen/VorarlbergFlag.png"
                         height="80" width="80" style="border: solid 1px grey; object-fit: cover;"/>
                    <img v-else-if="lvId==='19'" src="../../../../assets/wappen/Wien.png" width="60"/>
                    <img v-else src="../../../../assets/oeskb.png" width="100"/>
                </td>
                <td style="width: 18cm">
                    <div v-if="lvId==='1'" class="pageHeader primary--text">ÖSTERREICHISCHER SPORTKEGEL- und BOWLINGVERBAND</div>
                    <div v-else class="pageHeader primary--text text-uppercase">{{ landesverband }}</div>
                    <div class="pl-2">
                        <slot></slot>
                    </div>
                </td>
                <td v-if="lvId!=='1'" style="width: 100px">
                    <img src="../../../../assets/oeskb.png" width="100"/>
                </td>
            </tr>
        </table>
        <v-divider/>
    </div>
</template>

<script>
export default {
    name: "meisterschaftPrintHeader",
    props: ['lvId'],
    computed: {
        landesverband(){ return "Landesverband " +
            this.$store.state.local.landesverbaende.find(lv => lv.id === this.lvId)?.nameShort },
    },
}
</script>

<style scoped>
    .pageHeader {font-size: 16px; font-weight: bold; padding-left: 8px}
</style>